export default __webpack_public_path__ + "static/media/ideas_2.d29c0afd.png";